
export const NetworkInfo = {
    protocol: 'http',
    host: 'localhost',
    authHost: 'localhost',
    port: 8000,
    authPort:8001,
    apiPath: '/api',
    auth:'/auth',    
    get baseURL() {     
      const url =  process.env.REACT_APP_API_URL 
      return url;
    },
    get baseAuthURL() {
      // const url = process.env.REACT_APP_AUTH_URL
      const url = process.env.REACT_APP_API_URL  
      return url;
    },
    endpoints: {
      api:'api',
      auth:'auth',
      insights:'insights',
      subscription:'subscription',
      plans:'/plans',
      quicksight:'/quicksight',
      support:'/support',
      discussion:'/discussion',
      feedback:'/feedback',
      embedUrl:'/embedUrl',
      logout:'/logout',
      login:'/login',
      switchClient:'/switch-client',
      sessions:'/sessions',
      news:'news',
      catalog:'catalog',
      client:'/client',
      webclient:'client',
      webuser:'/webuser',
      webclients:'/clients',
      assignClient:'/assign-client',
      user:'/user',
      licenses:'/licenses',
      getUserLicenses:'/getUserLicenses',
      pending:'/pending',
      assigned:'/assigned',
      request:'/request',
      refreshToken:'/refresh-token',
      verifyUser:'/verify-user',
      create:'/create',
      approve:'/approve',
      listuser:'/listuser',
      clientembedUrl:'/clientembedUrl',
    },
};

